export function alertMessage() {
    //console.log('alert loaded');
}